import React from 'react';
import PropTypes from 'prop-types';
import ProgressPopoverContent from './ProgressPopoverContent';
import { PopoverContent as AdminPopoverContent } from '../admin/';

// legacy imports
import { isAssignmentInProgress } from 'legacy/src/components/learnosity/utils/helpers';
import { SubunitAssessmentTypes } from 'legacy-packages/unit-outline/src/constants';

// chameleon imports
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import {
  ProgressButton,
  SingleAssignmentProgress,
} from 'chameleon/ui-stack/ui/units/subunit-content/ppc';
import './AssessmentProgress.scss';

const AssessmentProgress = (props) => {
  const {
    assignments,
    isAdminOrCoordinator,
    ppcType,
    adminMessage,
    subunitType = SubunitAssessmentTypes.PPC,
    disablePpcAutoAssignFlag,
  } = props;

  //performance icon (yellow and green) is shown when 80%+ students finished assignment
  let isPerformance = assignments.some((assignment) => {
    const { progress } = assignment;
    return !isAssignmentInProgress(progress);
  });

  // FY-6874-FY-9063: for admin and coord show the performance
  // icon for the first mcq ppc and first PreAP Unit Quiz
  if (
    isAdminOrCoordinator &&
    ppcType &&
    (ppcType.includes('MCQ') || ppcType.includes('PreAP_Quiz_1'))
  ) {
    isPerformance = true;
  }

  const renderPopoverContent = () => {
    if (isAdminOrCoordinator) {
      const adminContentHeaders = {
        PPC: 'Progress Check (All Progress)',
        PE: 'Practice Exam (All Progress)',
      };
      return (
        <AdminPopoverContent
          subunitType={subunitType}
          ppcType={ppcType}
          adminMessage={adminMessage}
          popoverHeader={adminContentHeaders[subunitType]}
          disablePpcAutoAssignFlag={disablePpcAutoAssignFlag}
        />
      );
    }

    return <ProgressPopoverContent {...props} />;
  };

  // FY-20135 -> if one assignment return just the bar UX refresh requirement
  // https://academicmerit.atlassian.net/browse/FY-23754
  // for PPC show the signle performance bar
  // fo PE show the View All btton
  if (
    assignments.length === 1 &&
    subunitType === SubunitAssessmentTypes.PPC &&
    !disablePpcAutoAssignFlag
  ) {
    return <SingleAssignmentProgress assignments={assignments} />;
  }
  return (
    <div className="assessment-progress">
      <PopOver
        isNarrow
        closeButtonSize="small"
        trigger={<ProgressButton isPerformance={isPerformance} />}
      >
        {renderPopoverContent()}
      </PopOver>
    </div>
  );
};

AssessmentProgress.propTypes = {
  disablePpcAutoAssignFlag: PropTypes.bool,
  unitNumber: PropTypes.string,
  unitTitle: PropTypes.string,
  assessmentId: PropTypes.string,
};

AssessmentProgress.defaultProps = {
  disablePpcAutoAssignFlag: false,
  unitNumber: null,
  unitTitle: null,
  assessmentId: null,
};

export default AssessmentProgress;
